"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmPropertyItemNumberAttitudeScale = void 0;
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../../models");
var ConfirmPropertyItem_1 = require("../ConfirmPropertyItem");
var ConfirmPropertyItemNumberAttitudeScale = function (_a) {
    var value = _a.value, scaleStart = _a.scaleStart, scaleEnd = _a.scaleEnd, _b = _a.leftLabel, leftLabel = _b === void 0 ? '' : _b, _c = _a.rightLabel, rightLabel = _c === void 0 ? '' : _c, className = _a.className, color = _a.color, propertyId = _a.propertyId;
    var leftLabelText = leftLabel === '' ? scaleStart : "".concat(scaleStart, " ").concat(leftLabel);
    var rightLabelText = rightLabel === '' ? scaleEnd : "".concat(scaleEnd, " ").concat(rightLabel);
    var displayLabel = value
        ? "".concat(value, "\uFF08").concat(leftLabelText, "\u301C").concat(rightLabelText, "\uFF09")
        : '';
    return (react_1.default.createElement(ConfirmPropertyItem_1.ConfirmPropertyItem, { propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.number, inputFormatType: models_1.NUMBER_PROPERTY_INPUT_TYPE.attitudeScale, className: className, color: color }, displayLabel));
};
exports.ConfirmPropertyItemNumberAttitudeScale = ConfirmPropertyItemNumberAttitudeScale;
